import React, { useState, useCallback, useEffect } from "react";
import { requestPending, requestPristine } from "state/reducer/requestStatusSlice";
import {  selectorAPI, addDelegation } from "net/contracts";
import { useDispatch, useSelector } from "react-redux";
import { ISelectLabel } from "@ds/ds-snam/dist/models/select";
import {  Row, Col } from "react-grid-system";
import "views/contractView/styles/newElementFormStyles.css";
import { DatePicker, Button, InputAttach, Select } from "@ds/ds-snam/react";
import {  useNavigate } from "react-router-dom";
import { DATE_FORMAT, RoutePath,  DocumentType, EntityType, DsLayout, ResponseStatus, ResponseCode } from "shared/constants";
import {  IDocument, IDelegation } from "dataModels/contract";
import { FileStatusEnum, IFileUpload } from "dataModels/fileInput";
import moment from "moment";
import DSFileInput from "components/DSFileInput";
import { INotificationAction, NotificationsStatusType } from "dataModels/stateModels/notification";
import { showNotification, hideNotification } from "state/reducer/notificationSlice";
import { useTranslation } from "react-i18next";
import { DSFile } from "@ds/ds-snam";
import { dsSelectHandler } from "shared/utils/dsComponentUtils";
import { RootState } from "state/appStore";




interface Selector {
    id: string;
    label: string;
    value: string;
}
const getDefaultFormData = (): IDelegation => {
    const defaultFormData: IDelegation = {
        delegationId:"", //stringa vuota
        transporterId:"",
        businessId:"",
        businessName:"", //stringa vuota
        document:{
            type: '',
            name: '',
            size: 0,
            content: '',
            expire: null,
            status: 0, 
        },
        delegationAbilitation:true
    }
    return defaultFormData;
}
const DelegationForm: React.FC = (): JSX.Element => {

    const [customerList, setCustomerList] = useState<ISelectLabel[]>([]);
    const [transporterList, setTransporterList] = useState<ISelectLabel[]>([]);
    const layoutMode = useSelector((state:RootState)=>{
        return state.dsLayout.mode;
    })

    const [formData, setFormData] = useState<IDelegation>(/*formMode === FormMode.NEW ? */getDefaultFormData()/* : contractData*/);
    const [formStep, setFormStep] = useState<number>(0);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation(['contract','app']);

    useEffect(() => {
        dispatch(requestPending());
        selectorAPI(EntityType.BUSINESS)
            .then((response: ISelectLabel[]) => {
                setCustomerList(response)
            })
            .catch(error => {
                console.log(error);
            })
            .finally(() => {
                dispatch(requestPristine());
            })
    }, [dispatch]);

    useEffect(()=>{
        if(formData.businessId!==''){
            dispatch(requestPending());
            selectorAPI(EntityType.TRANSPORTER,formData.businessId)
                .then((response: ISelectLabel[]) => {
                    setTransporterList(response)
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    dispatch(requestPristine());
                });
        }
        
    },[formData.businessId])

    const onDateInputChange = (inputEvent: Event, fieldName: string) => {
        const date: string = (inputEvent as CustomEvent).detail.dateSelection;
        if(formData.document!==null){
            formData.document.expire = moment.utc(date, DATE_FORMAT).unix();
        }
    }

    const saveFormData = useCallback(() => {
        dispatch(requestPending());
        addDelegation(formData)
            .then((response) => {
                //gestione errori business
                const popUpTitle:string = response.status===ResponseStatus.ERROR ? 'Error':(response.code===ResponseCode.UNPROCESSABLE_CONTENT? "Warning": t("transporter.delegationForm.popupTitle") );
                const popUpDescription:string = response.status===ResponseStatus.ERROR||response.code===ResponseCode.UNPROCESSABLE_CONTENT?response.message:t("transporter.delegationForm.popupText");
                const popUpStatus:NotificationsStatusType = response.status===ResponseStatus.ERROR?"error":(response.code===ResponseCode.UNPROCESSABLE_CONTENT?"warning":"confirm");
                            
                let popUpAction: INotificationAction;
                popUpAction = {
                    show: true,
                    title: popUpTitle,
                    description: popUpDescription,
                    status: popUpStatus,
                    onClose: (event: Event) => {
                        dispatch(hideNotification());
                    }
                };
                dispatch(showNotification(popUpAction));
                navigate(RoutePath.CONTRACTS_TRANSPORTATORS_INFO);
            })
            .catch(error => {
                console.log(error);
            })
            .finally(() => {
                dispatch(requestPristine());
            })
           
    }, [ dispatch, navigate,formData]);

    const validateStep = (): number => {
        let errors: number = 0;
        if (formStep === 1) {

            const elem: DSFile | null = document.querySelector("[input-id='doc']");
            let koCheck = false;
            if (formData.document.name === '') {
                koCheck = true;
            }
            if (koCheck)
                errors++;
            if (elem)
                if (elem.inputStatus === 'uploaded') {
                    //elem.inputStatus = elem.inputStatus;
                } else {
                    if (koCheck) {
                        //console.log('entro in ',i, ' error')
                        elem.inputStatus = 'error'
                    } else {
                        //console.log('entro in ',i, ' default')
                        elem.inputStatus = 'default'
                    }
                }
        } 
        return errors;
    }
    
    return (

        <>
            {formStep===0 &&   
                <>
                    <p className="pageTitle" style={{ marginBottom: "10px" }}>{t("transporter.delegationForm.title_1")}</p> {/* Delega trasportatore*/}
                    {/*<p className="pageSubTitle" style={{ marginBottom: "30px" }}>{t("transporter.delegationForm.title_2")}</p>*/} {/**Scegli il trasportatore da delegare tra quelli presenti in piattaforma e approvati */}
                    <Row>
                        <Col xs={3}>
                            <div className="textInputWrapper">
                                <Select
                                    id="customerSelector"
                                    menuPlaceholder=""
                                    hasIcon={false}
                                    menuOptions={customerList}
                                    menuLabel={t("transporter.delegationForm.choseClient")}/*'Scegli il cliente di riferimento'*/
                                    menuId="select-id"
                                    isDisabled={false}
                                    selectStatus="default"
                                    onOptionSelection={(event: Event) => {
                                        const customer: ISelectLabel = (event as CustomEvent).detail.option;
                                        dsSelectHandler(customerList, customer);
                                        let currentFormData = { ...formData };
                                        currentFormData.businessId=customer.value!;
                                        setFormData(currentFormData)
                                        //setSelectedCustomer(customer);
                                    }}
                                ></Select>
                                <div style={{height:'16px'}}></div>
                                <Select
                                    id="transportSelector"
                                    menuPlaceholder=""
                                    hasIcon={false}
                                    menuOptions={transporterList} 
                                    menuLabel={t("transporter.delegationForm.choseTransporter")}/*'Scegli il trasportatore di riferimento'*/
                                    menuId="select-id"
                                    isDisabled={formData.businessId===''?true:false}
                                    selectStatus="default"
                                    onOptionSelection={(event: Event) => {
                                        //console.log((event as CustomEvent).detail.option)
                                        const transporter: ISelectLabel = (event as CustomEvent).detail.option;
                                        dsSelectHandler(transporterList, transporter);
                                        let currentFormData = { ...formData };
                                        currentFormData.transporterId=transporter.value!;
                                        setFormData(currentFormData)
                                        //setSelectedTranspoter(transporter);
                                    }}
                                ></Select>
                            </div>
                            <Button
                                buttonType="button"
                                buttonUIVariant="secondary"
                                buttonSize="medium"
                                buttonLabel={t("transporter.delegationForm.insertTransporter")}//'Inserisci trasportatore'
                                buttonIcon="icon-add"
                                //isDisabled={!selectedContractId}
                                isDisabled={false}
                                buttonAriaLabel="insert customer button"
                                onClickEvent={() => {
                                    navigate(RoutePath.CONTRACTS_NEW_TRANSPORT)
                                }}
                            ></Button>
                        </Col>
                    </Row>
                    {(formData.businessId!=='' && formData.transporterId!=='') &&
                        <Row style={{marginTop:'30px'}}>
                            <Col xs={12}>
                                <Button
                                    style={{ marginRight: "0.8rem",float:'right' }}
                                    id="backButton"
                                    buttonType="button"
                                    buttonUIVariant="primary"
                                    buttonSize="medium"
                                    buttonLabel={t('general.buttons.next', { ns: 'app' })}
                                    buttonIcon=""
                                    onClickEvent={() => { 
                                        setFormStep(1);
                                    }}
                                />
                            </Col>
                        </Row>
                    }
                    
                </>
            }
            {formStep===1 &&
                <>
                    <p className="pageTitle" style={{ marginBottom: "10px" }}>{t("transporter.delegationForm.title_3")}{/*Inserisci delega}*/}</p>
                    <div className="listTableContainerGrey">
                    <Row>
                        <Col xs={6}>
                                
                                <Row>
                                    <Col>
                                        <div className="formSubTitle">
                                        {t("transporter.delegationForm.title_4")}{/*Inserisci la delega relativa all'azienda trasportatrice}*/}
                                        </div>
                                    </Col>
                                </Row>
                            
                            <Row>
                                    <Col>
                            <div className="fileInputWrapper">
                                <DSFileInput
                                    title={t("transporter.delegationForm.delegationAct")}//'Atto di delega del cliente*'
                                    inputLabel={formData.document.size===0 ? t('dsComponents.fileInput.uploadedStatus.title', { ns: 'app' }) : t('dsComponents.fileInput.defaultStatus.title', { ns: 'app' })}
                                    buttonText={t('dsComponents.fileInput.defaultStatus.subTitle', { ns: 'app' })}
                                    id="doc"
                                    accept="application/pdf, image/jpg, image/jpeg"
                                    maxSize={10000000}
                                    defaultStatus={formData.document.size!==0 ? FileStatusEnum.UPLOADED : FileStatusEnum.DEFAULT}
                                    onFileUpload={(fileUpload: IFileUpload, id: string) => {
                                        //console.log("on file upload", fileUpload, id);
                                        let currentFormData = { ...formData };
                                        let base64String = btoa(fileUpload.content);
                                        const documentObj: IDocument = {
                                            type: DocumentType.DELEGATION, //"contract",
                                            name: fileUpload.name,
                                            size: fileUpload.size,
                                            content: base64String,
                                            expire: moment(new Date(), DATE_FORMAT).unix(),
                                            //status:null
                                        }
                                        currentFormData.document = documentObj;
                                        setFormData(currentFormData);
                                    }}
                                />
                            </div>
                            </Col>
                            </Row>
                            <Row>
                            {formData.document.name &&
                                <div className="uploadedFileWrapper" style={{paddingLeft:'16px'}}>
                                    <InputAttach
                                        attachName={formData.document.name}
                                        firstButtonDisabled={false}
                                        secondButtonDisabled={false}
                                        inputLabel={t('contract.contractForm.sections.fileInput.attachTitle')}//"File caricato"
                                    />
                                </div>
                            }
                            {formData.document.name &&
                                <Col xs={12} md={3}>
                                    <div className="expirationInputWrapper" style={{width:'196px'}}>
                                        <DatePicker
                                            id="scadenzaDocDelegation"
                                            datePickerTitle={t("transporter.delegationForm.expire")}//"scadenza"
                                            isRangePicker={false}
                                            datePickerVariant="full-date"
                                            datePickerPlaceholder=""
                                            startingYear={new Date().getFullYear()}
                                            endingYear={2099}
                                            defaultDate={new Date()}
                                            isDisabled={false}
                                            datePickerStatus="default"
                                            confirmButtonLabel="Conferma"
                                            disabledDates={{ lastDisabledDate: new Date(Date.now() - 86400000) }} 
                                            hasCloseButton={false}
                                            zIndex={999}
                                            isReadonly={false}
                                            isPanelTop={true}
                                            onDateSelection={(event: Event) => {
                                                onDateInputChange(event, 'startDate')
                                            }}
                                        ></DatePicker>
                                    </div>
                                </Col>
                            }</Row>
                        </Col>
                    </Row>
                    </div>
                    <Row style={{marginTop:'30px'}}>
                        <Col xs={12}>
                            <Button
                                style={{ marginRight: "0.8rem",float:'right' }}
                                id="backButton"
                                buttonType="button"
                                buttonUIVariant="primary"
                                buttonSize="medium"
                                buttonLabel={t('general.buttons.next', { ns: 'app' })}
                                buttonIcon=""
                                isDisabled={false}
                                onClickEvent={() => { 
                                    let errors = validateStep();
                                    if(errors===0){
                                        saveFormData();
                                    }
                                }}
                            />
                            <Button
                                style={{ marginRight: "0.8rem",float:'right' }}
                                id="backButton"
                                buttonType="button"
                                buttonUIVariant="secondary"
                                buttonSize="medium"
                                buttonLabel={t('general.buttons.back', { ns: 'app' })}
                                buttonIcon=""
                                isDisabled={false}
                                onClickEvent={() => { 
                                    setFormStep(0);
                                }}
                            />
                        </Col>
                    </Row>
                </>
            }
            
        </>
    )
}
export default DelegationForm;